import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ROUTES } from "../routes/routes";
import ThemeSwitcher from "./Themeswitcher";
import { ThemeArea } from "../context/ThemeContext";
import { Hamburgernav } from "./Hamburgernav";

export default function Navigation() {
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            navigate(`/search/${encodeURIComponent(searchQuery.trim())}`);
        }
    };

    return (
        <nav>
            <div className="nav-container">
                <h4 className="nav-title">
                    <NavLink to={ROUTES.home.path}>PGM</NavLink>
                </h4>
                <ul>
                    <li className="nav-item">
                        <NavLink to={ROUTES.home.path}>Home</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={ROUTES.project.path}>Portfolio</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={ROUTES.blog.path}>Blog</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={ROUTES.opleiding.path}>Opleiding</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={ROUTES.services.path}>Services</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={ROUTES.programma.path}>Programma</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={ROUTES.team.path}>Onze team</NavLink>
                    </li>
                    <li>
                        <form onSubmit={handleSearchSubmit}>
                            <input
                                type="text"
                                placeholder="Search.."
                                className="search-nav"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </form>
                    </li>
                </ul>
                <ThemeArea>
                    <ThemeSwitcher />
                </ThemeArea>
            </div>
            <Hamburgernav />
        </nav>
    );
}
